// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2svcB","right":"styles_right__3DJeK"};